import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/esm/Container";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Stack from "react-bootstrap/Stack";
import useUser from "../../../../../hooks/useUser";
import { CgDanger } from "react-icons/cg";
import Spinner from "react-bootstrap/Spinner";
import { newUserByFormAptosVetex } from "../../../../../api/apiNewUser";
import "./PreferenceData.css";
import ErrorTooltip from "../ErrorTooltip";
import { useMediaQuery } from "react-responsive";
//import { set } from "mongoose";
//import { useNavigate } from "react-router";

const PreferenceData = () => {
  const [
    dataUser,
    setDataUser,
    dataAdmin,
    setDataAdmin,
    initialDataUser,
    dataLocalStorage,
    setDataLocalStorage,
  ] = useUser();
  const { phoneUser, cuponType, tyc, privacy, newsLetter } = dataUser;
  //dataUser.newsLetter=true;
  const [showSpinner, setShowSpinner] = useState(false);
  const [registerComplete, setRegisterComplete] = useState(false);
  const [hideSendRegisterButton, setHideSendRegisterButton] = useState(true);
  const [isRetryOn, setIsRetryOn] = useState(true);
  const isMobile = useMediaQuery({ query: "(max-width: 400px)" });

  //const [continuar, setContinuar] = useState(false);
  //const navigate = useNavigate();
  useEffect(() => {
    if (newsLetter !== true) {
      setDataUser({
        ...dataUser,
        registerDomain: "internal",
        registerType: "normal",
        newsLetter: true,
        isValidPhoneUser: true,
      });
    }
  }, []);

  useEffect(() => {
      //console.log('isRetryOn:..',String(isRetryOn));
  }, [isRetryOn]);

  useEffect(()=>{
    if(dataUser.registerComplete===true){
      setDataLocalStorage({});
    }
  },[dataUser.registerComplete])

  useEffect(() => {
    if (
      dataUser.isValidFenac &&
      dataUser.userFenac &&
      dataUser.fenacUser === ""
    ) {
      setDataUser({
        ...dataUser,
        fenacUser: dataUser.userFenac.toISOString(),
      });
    } else if (
      !dataUser.isValidFenac &&
      dataUser.userFenac &&
      dataUser.fenacUser !== ""
    ) {
      setDataUser({
        ...dataUser,
        fenacUser: "",
      });
    }
  }, [dataUser.isValidFenac, dataUser.userFenac, dataUser.fenacUser]);

  useEffect(() => {
    //console.log("dataRegister was updated...", dataUser.dataRegister);

    if (
      tyc &&
      dataUser.isValidFenac &&
      privacy &&
      dataUser.cuponType &&
      dataUser.isValidPaterno &&
      dataUser.isValidNameUser &&
      dataUser.isValidZipCode &&
      dataUser.isValidPhoneUser &&
      dataUser.isValidCityUser &&
      dataUser.isValidStateUser
    ) {
      setHideSendRegisterButton(false);
    } else {
      setHideSendRegisterButton(true);
    }
    if (showSpinner) {
      setHideSendRegisterButton(true);
    }
    if (dataUser.succedRegister) console.log("succedRegister:..true");
    if (registerComplete) {
      /*setDataUser({
        ...dataUser,
        registerComplete: true
      })
      
      */
      console.log("Registro Completo:...");
      //window.location.reload();
    }
    /*if (dataUser.userPreferences){
      console.log('Intereses:..',dataUser.userPreferences);
    }*/

    return;
  }, [
    registerComplete,
    showSpinner,
    dataUser,
    dataUser.succedRegister,
    dataUser.isValidMaterno,
    dataUser.isValidNameUser,
    dataUser.isValidPaterno,
  ]);
  useEffect(() => {
    //console.log("dataUser was updated...", dataUser);
  }, [dataUser.tyc]);
  const handleCheck = (e) => {
    let option = e.target.value;
    let add = e.target.checked;
    let tempArray = [];
    if (add === true) {
      tempArray =
        dataUser.userPreferences?.length > 0 ? dataUser.userPreferences : [];
      tempArray.push(option);
      setDataUser({
        ...dataUser,
        userPreferences: tempArray,
      });
    } else {
      if (dataUser.userPreferences?.length === 1) tempArray = [];
      else tempArray = dataUser.userPreferences.filter((op) => op !== option);
      setDataUser({
        ...dataUser,
        userPreferences: tempArray,
      });
    }
    //console.log(preferences);
    //console.log('Checando:',e.target.value);
    //console.log('IsChecked:',e.target.checked);
  };
  const handleChange = (e) => {
    e.preventDefault();
    setDataUser({
      ...dataUser,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeChecked = (e) => {
    console.log(e.target.name, e.target.checked);
    if(e.target.name==='tyc'){
      setDataUser({
        ...dataUser,
        [e.target.name]: e.target.checked,
        privacy: e.target.checked,
      });
    }else{
      setDataUser({
        ...dataUser,
        [e.target.name]: e.target.checked,
      });
    }
    

    //console.log(`${e.target.name}::${e.target.checked}`);
  };

  useEffect(() => {
    if (dataUser.phoneUser.length > 0 ) {
      validatePhoneUser(dataUser.phoneUser)
    }
    if(dataUser.phoneUser.length===0){
      setDataUser({
        ...dataUser,
        isValidPhoneUser: true,
      });
    }
  },[dataUser.phoneUser])

  const validatePhoneUser = (phone) => {
    //console.log('validando phoneUser:..',phone);
    
    let tempPhone = phone.replace(/[^0-9]/g, "");
    if (tempPhone.length === 10) {
      setDataUser({
        ...dataUser,
        phoneUser: tempPhone,
        isValidPhoneUser: true,
      });
      return;
    } 
    if(tempPhone.length>0&&tempPhone.length!==10) {
      setDataUser({
        ...dataUser,
        isValidPhoneUser: false,
      });
      return;
    }
  }

  const sendDataForm = async () => {
    setDataUser({
      ...dataUser,
      succedRegister: true,
    });
    //window.navigator.onLine ? console.log('trabajando:.. online') : console.log('trabajando:.. offline');
    
    
    console.log("Enviando datos de usuario...", dataUser);
    console.log("Esperando respuesta del Backend...");
    let res = await newUserByFormAptosVetex({
      ...dataUser,
      registerDomain: "internal",
        registerType: "normal",
    
    });
    console.log("respuesta del Backend:..", res);
    

    if(res){
      if(res.data){
        const {idAptos, idCL, idMF} = res.data;
        if(idAptos && idCL && idMF){
          setDataLocalStorage({});
        }else{
          setTimeout(()=>{
            setDataLocalStorage({...dataUser});
          },3000)
        }
      }
      if(!res.data){
        setTimeout(()=>{
          setDataLocalStorage({...dataUser});
        },3000)
        
      }
    }
      
      


    if (res.data) {
      let tempObj = {};
      
      
      if (res.data.message) {
        setDataUser({
          ...dataUser,
          errorMessage: res.data.message,
        });
      }
      if (res.data.isFounded) {
        tempObj = {
          ...tempObj,
          isFounded: res.data.isFounded || "",
        };
      }

      if (res.data.idAptos) {
        tempObj = {
          ...tempObj,
          idAptos: res.data.idAptos || "",
        };
      }
      if (res.data.idCL) {
        tempObj = {
          ...tempObj,
          idCL: res.data.idCL || "",
        };
      }
      if (res.data.idMF) {
        tempObj = {
          ...tempObj,
          idMF: res.data.idMF || "",
        };
      }
      if (res.data.alreadyRegistered) {
        tempObj = {
          ...tempObj,
          alreadyRegistered: true,
        };
      }

      //console.log("tempObj(dataRegister):", tempObj);

      if (tempObj.idAptos && tempObj.idCL && tempObj.idMF) {
        if(tempObj.alreadyRegistered){
          console.log("Cliente Actualmente Ya Registrado...");
          setDataUser({
            ...dataUser,
            pageReload: true,
            registerComplete: true,
            dataID: tempObj,
            alreadyRegistered: true,
          });
          setIsRetryOn(false);
          setRegisterComplete(true);
          setDataLocalStorage({});

        }else{
          console.log("Registro de Cliente Exitoso...");
        setDataUser({
          ...dataUser,
          pageReload: true,
          registerComplete: true,
          dataID: tempObj,
        });
        setIsRetryOn(false);
        setRegisterComplete(true);
        setDataLocalStorage({});
        }
        
        //navigate('/');
      }
      if (tempObj.idAptos && tempObj.idCL && !tempObj.idMF) {
        setDataUser({
          ...dataUser,
          pageReload: true,
          registerComplete: true,
          registerInComplete: "Error en el objeto MF:..",
          dataID: tempObj,
        });
        console.log("Registro inCompleto error en idMF:..");
        setRegisterComplete(true);
      }
      if (tempObj.idAptos && !tempObj.idCL && tempObj.idMF) {
        setDataUser({
          ...dataUser,
          pageReload: true,
          registerComplete: true,
          registerInComplete: "Error en el objeto CL:..",
          dataID: tempObj,
        });
        console.log("Registro inCompleto error en idCL:..");
        setRegisterComplete(true);
      }
      if (!tempObj.idAptos && tempObj.idCL && tempObj.idMF) {
        setDataUser({
          ...dataUser,
          pageReload: true,
          registerComplete: true,
          registerInComplete: "Error en el idAptos:..",
          dataID: tempObj,
        });
        console.log("Registro inCompleto error en idAptos:..");
        setRegisterComplete(true);
      }
    }
  };

  return (
    <div style={{ borderLeft: "1px solid #bbbbbb50" }} className="ps-1 w-100">
      <Form>
        {/* <Row className="userPreferences">
          <h2 className="text-primary fs-5">
            Intereses (selecciona al menos uno):
            {(!dataUser.userPreferences ||
              dataUser.userPreferences?.length === 0 ||
              dataUser.userPreferences === []) && (
              <ErrorTooltip msg={"Al menos uno"} />
            )}
          </h2>
          <Col>
            <Form.Group className="mb-3" id="formGridHome">
              <Form.Check
                type="checkbox"
                value="Hogar"
                checked={
                  userPreferences?.find((el) => el === "Hogar") ? true : false
                }
                onChange={handleCheck}
                label="Hogar"
              />
            </Form.Group>
            <Form.Group className="mb-3" id="formGridSports">
              <Form.Check
                type="checkbox"
                value="Deportes"
                checked={
                  userPreferences?.find((el) => el === "Deportes")
                    ? true
                    : false
                }
                onChange={handleCheck}
                label="Deportes"
              />
            </Form.Group>
            <Form.Group className="mb-3" id="formGridTech">
              <Form.Check
                type="checkbox"
                value="Tecnología"
                checked={
                  userPreferences?.find((el) => el === "Tecnología")
                    ? true
                    : false
                }
                onChange={handleCheck}
                label="Tecnología"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" id="formGridH&B">
              <Form.Check
                type="checkbox"
                value="Salud y Belleza"
                checked={
                  userPreferences?.find((el) => el === "Salud y Belleza")
                    ? true
                    : false
                }
                onChange={handleCheck}
                label="Salud y Belleza"
              />
            </Form.Group>
            <Form.Group className="mb-3" id="formGridSnacks">
              <Form.Check
                type="checkbox"
                value="Snacks"
                checked={
                  userPreferences?.find((el) => el === "Snacks") ? true : false
                }
                onChange={handleCheck}
                label="Snacks"
              />
            </Form.Group>
            <Form.Group className="mb-3" id="formGridTravel">
              <Form.Check
                type="checkbox"
                value="Viajes"
                checked={
                  userPreferences?.find((el) => el === "Viajes") ? true : false
                }
                onChange={handleCheck}
                label="Viajes"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" id="formGridFashion">
              <Form.Check
                type="checkbox"
                value="Moda"
                checked={
                  userPreferences?.find((el) => el === "Moda") ? true : false
                }
                onChange={handleCheck}
                label="Moda"
              />
            </Form.Group>
            <Form.Group className="mb-3" id="formGridCook">
              <Form.Check
                type="checkbox"
                value="Cocina"
                checked={
                  userPreferences?.find((el) => el === "Cocina") ? true : false
                }
                onChange={handleCheck}
                label="Cocina"
              />
            </Form.Group>
            <Form.Group className="mb-3" id="formGridPets">
              <Form.Check
                type="checkbox"
                value="Mascotas"
                checked={
                  userPreferences?.find((el) => el === "Mascotas")
                    ? true
                    : false
                }
                onChange={handleCheck}
                label="Mascotas"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" id="formGridToys">
              <Form.Check
                type="checkbox"
                value="Juguetes"
                checked={
                  userPreferences?.find((el) => el === "Juguetes")
                    ? true
                    : false
                }
                onChange={handleCheck}
                label="Juguetes"
              />
            </Form.Group>
            <Form.Group className="mb-3" id="formGridStationery">
              <Form.Check
                type="checkbox"
                value="Papelería"
                checked={
                  userPreferences?.find((el) => el === "Papelería")
                    ? true
                    : false
                }
                onChange={handleCheck}
                label="Papelería"
              />
            </Form.Group>
          </Col>
        </Row> */}
        <Form.Group as={Col} controlId="formGridMaterno" className="mb-3">
            <Form.Label className="text-muted">Número de Contacto:</Form.Label>
            {!dataUser.isValidPhoneUser && <ErrorTooltip msg={"Número Invalido"} />}
            <Container className="d-flex">
              <Form.Control
                value={phoneUser ? phoneUser : ""}
                name="phoneUser"
                onChange={handleChange}
                placeholder="Número"
              />
            </Container>
            
          </Form.Group>
        <Row className="cuponType">
          <Container className="w-100">
            <h2 className={isMobile?"text-primary fs-6":"text-primary fs-5"}>
              ¿Dónde quieres aplicar tu cupón de bienvenida?
              {!dataUser.cuponType && <ErrorTooltip msg={"Favor de elegir"} />}
            </h2>
          </Container>
          <Col>
            <Form.Group className="mb-3" id="formGridPremises">
              <Form.Check
                value="store"
                name="cuponType"
                checked={cuponType === "store" ? true : false}
                onChange={handleChange}
                type="radio"
                label="Tienda Física"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" id="formGridOnline">
              <Form.Check
                value="onLine"
                name="cuponType"
                checked={cuponType === "onLine" ? true : false}
                onChange={handleChange}
                type="radio"
                label="Tienda en Línea"
              />
            </Form.Group>
          </Col>
        </Row>
        {/**Settings Section */}
        <Stack
          gap={1}
          className="bg-secondary bg-opacity-25 border rounded text-dark w-75 ms-auto me-auto mt-4 p-2"
        >
          <Form.Group className="mb-3" id="formGridNewsletter">
            <Form.Check
              name="newsLetter"
              onChange={handleChangeChecked}
              checked={newsLetter === true ? true : false}
              type="checkbox"
              label="Quiero recibir el newsletter con promociones"
            />
          </Form.Group>
          <Form.Group
            className="mb-3 d-flex align-items-center"
            id="formGridTerms"
          >
            <Form.Check
              type="checkbox"
              name="tyc"
              onChange={handleChangeChecked}
              label="Acepto los términos, condiciones y el aviso de privacidad"
            />
            {!tyc && <ErrorTooltip msg={"Favor de Aceptar"} />}
          </Form.Group>
          <Form.Group
            className="mb-3 d-flex align-items-center d-none"
            id="formGridPrivacy"
          >
            <Form.Check
              type="checkbox"
              name="privacy"
              onChange={handleChangeChecked}
              label="Acepto el aviso de privacidad"
            />
            {!privacy && <ErrorTooltip msg={"Favor de Aceptar"} />}
          </Form.Group>
        </Stack>
      </Form>
      {/* {(!dataUser.userPreferences ||
        dataUser.userPreferences?.length === 0 ||
        dataUser.userPreferences === []) && (
        <h2 className="text-danger fs-6 text-center mt-4">
          *Intereses (recuerda seleccionar almenos uno)
        </h2>
      )} */}

      {(!dataUser.isValidPaterno ||
        !dataUser.isValidCityUser ||
        !dataUser.isValidPhoneUser ||
        !dataUser.isValidStateUser ||
        !dataUser.isValidFenac ||
        !dataUser.isValidNameUser ||
        !dataUser.tyc ||
        !dataUser.privacy ||
        !dataUser.cuponType) && (
        <h2 className="text-danger fs-6 text-center mt-4">
          *Es necesario completar correctamente los campos obligatorios
        </h2>
      )}

      <Container className="w-100 d-flex justify-content-center">
        <Button
          onClick={sendDataForm}
          disabled={hideSendRegisterButton ? true : false}
          style={{
            border: "none",
            backgroundColor: "#ff000070",
            color: "#000",
          }}
          className="rojoHover w-100 mt-3 fw-bold"
        >
          {showSpinner ? (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : (
            "Enviar Registro"
          )}
        </Button>
        {dataUser.errorMessage !== "" && (
          <h4 className="text-danger fs-6">{dataUser.errorMessage}</h4>
        )}
      </Container>
    </div>
  );
};

export default PreferenceData;
